package games.polyclub.website.frontend.store.layout

import adminlte.pushmenu.PushMenu
import adminlte.pushmenu.PushMenuOperation
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.a
import games.polyclub.frontend.lib.react.simplified.tags.i
import games.polyclub.frontend.lib.react.simplified.tags.li
import jquery.jQuery
import react.Props
import react.createRef
import react.dom.aria.AriaRole
import react.useEffect
import web.html.HTMLAnchorElement

val PushMenu = SFC<Props> { _ ->
    val aRef = createRef<HTMLAnchorElement>()
    useEffect(aRef.current) {
        jQuery(aRef.current).PushMenu()
    }
    li("nav-item") {
        a("nav-link") {
            ref = aRef
            href = "#"
            role = AriaRole.button
            i("fas fa-bars")
            onClick = { ev ->
                ev.preventDefault()
                jQuery(ev.target).PushMenu(PushMenuOperation.TOGGLE)
            }
        }
    }
}
